import {
  ChangeDetectionStrategy,
  Component,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { ConfirmModalComponent, InfoBannerComponent } from '@catch/general-ui';
import { TranslocoPipe } from '@jsverse/transloco';
import { InvoiceBookingConfirmData } from '../../interfaces/invoice-booking-confirm';

@Component({
  selector: 'app-invoice-booking-confirm-modal',
  templateUrl: './invoice-booking-confirm-modal.component.html',
  styleUrl: './invoice-booking-confirm-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ConfirmModalComponent, InfoBannerComponent, TranslocoPipe],
})
export class InvoiceBookingConfirmModalComponent {
  private readonly modal = viewChild.required<ConfirmModalComponent>('modal');

  readonly lines = signal<InvoiceBookingConfirmData['lines']>([]);
  readonly totalLabel = signal('');
  readonly intervalLabel = signal<string | null>(null);
  readonly showProrationHint = signal(false);

  confirmed = output<void>();
  dismissed = output<void>();

  /**
   * Opens the invoice booking confirmation with cost details.
   * @param {InvoiceBookingConfirmData} data Lines, total and optional interval
   * @returns {void}
   */
  open(data: InvoiceBookingConfirmData): void {
    this.lines.set(data.lines);
    this.totalLabel.set(data.totalLabel);
    this.intervalLabel.set(data.intervalLabel ?? null);
    this.showProrationHint.set(!!data.showProrationHint);
    this.modal().modal.open();
  }
}
